var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeLogoMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 45C60 53.2875 53.2875 60 45 60C45 51.7125 51.7125 45 60 45Z",
    fill: "#FFCB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 39V45C51.7125 45 45 51.7125 45 60H39C39 48.4125 48.4125 39 60 39Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33V39C55.275 39 50.7 38.1375 46.5 36.6C50.475 34.3125 55.0875 33 60 33Z",
    fill: "#001A21"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27V33C55.0875 33 50.4375 31.9125 46.2375 30C50.4375 28.0875 55.0875 27 60 27Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 21V27C55.0875 27 50.475 25.6875 46.5 23.4C50.7 21.8625 55.275 21 60 21Z",
    fill: "#001A21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15V21C48.4125 21 39 11.5875 39 0H45C45 8.2875 51.7125 15 60 15Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0C53.2875 0 60 6.7125 60 15C51.7125 15 45 8.2875 45 0Z",
    fill: "#00F2F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 21C55.2751 21 50.7001 21.8625 46.5001 23.4C42.3751 21.0375 38.9626 17.5875 36.6001 13.5C38.1376 9.3 39.0001 4.7625 39.0001 0C39.0001 11.5875 48.4126 21 60.0001 21Z",
    fill: "#00F2F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5001 36.5999C50.7001 38.1374 55.2376 38.9999 60.0001 38.9999C48.4126 38.9999 39.0001 48.4124 39.0001 60C39.0001 55.275 38.1376 50.6999 36.6001 46.4999C39.0001 42.4124 42.4126 38.9624 46.5001 36.5999Z",
    fill: "#FFCB00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27.0001C55.0875 27.0001 50.4375 28.0876 46.2375 30.0001C44.1 29.0251 42.075 27.7876 40.2 26.4001C42.1875 25.2001 44.325 24.2251 46.5 23.4001C50.475 25.6876 55.0875 27.0001 60 27.0001Z",
    fill: "#FFCB00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2375 30C50.4375 31.9125 55.0875 33 60 33C55.0875 33 50.475 34.3125 46.5 36.6C44.2875 35.775 42.1875 34.8 40.2 33.6C42.075 32.175 44.1 30.975 46.2375 30Z",
    fill: "#00F2F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 13.5C38.9626 17.625 42.4126 21.0375 46.5001 23.4C44.2876 24.225 42.1876 25.2375 40.2001 26.4C37.6876 24.525 35.4751 22.3125 33.6001 19.8C34.8001 17.8125 35.7751 15.675 36.6001 13.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5001 36.5999C42.3751 38.9624 38.9626 42.4124 36.6001 46.4999C35.7751 44.2874 34.7626 42.1874 33.6001 40.1999C35.4751 37.6874 37.6876 35.4749 40.2001 33.5999C42.1876 34.7999 44.3251 35.7749 46.5001 36.5999Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2 26.4001C42.075 27.8251 44.1 29.0251 46.2375 30.0001C44.1 30.9751 42.075 32.1751 40.2 33.6001C38.4 32.5501 36.675 31.3126 35.0625 30.0001C36.675 28.6501 38.4 27.4501 40.2 26.4001Z",
    fill: "#001A21"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60H33C33 55.0875 34.3125 50.475 36.6 46.5C38.1375 50.7 39 55.2375 39 60Z",
    fill: "#001A21"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39 0C39 4.725 38.1375 9.3 36.6 13.5C34.3125 9.525 33 4.9125 33 0H39Z",
    fill: "#001A21"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 19.8C35.475 22.3125 37.6875 24.525 40.2 26.4C38.4 27.45 36.675 28.6875 35.0625 30C33.225 28.4625 31.5 26.775 30 24.9C31.35 23.325 32.55 21.6 33.6 19.8Z",
    fill: "#00F2F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2 33.5999C37.6875 35.4749 35.475 37.6874 33.6 40.1999C32.55 38.3999 31.3125 36.6749 30 35.0999C31.5375 33.2624 33.225 31.5374 35.0625 30.0374C36.675 31.3124 38.4 32.5499 40.2 33.5999Z",
    fill: "#FFCB00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33 0C33 4.9125 34.3125 9.525 36.6 13.5C35.775 15.7125 34.7625 17.8125 33.6 19.8C32.175 17.925 30.975 15.9 30 13.7625C31.9125 9.5625 33 4.9125 33 0Z",
    fill: "#FFCB00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6 46.5C34.3125 50.475 33 55.0875 33 60C33 55.0875 31.9125 50.4375 30 46.2375C30.975 44.1 32.2125 42.075 33.6 40.2C34.8 42.1875 35.775 44.2875 36.6 46.5Z",
    fill: "#00F2F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H33C33 4.9125 31.9125 9.5625 30 13.7625C28.0875 9.5625 27 4.9125 27 0Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33 60H27C27 55.0875 28.0875 50.4375 30 46.2375C31.9125 50.4375 33 55.0875 33 60Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35.1001C32.7959 35.1001 35.0625 32.8167 35.0625 30.0001C35.0625 27.1834 32.7959 24.9001 30 24.9001C27.2041 24.9001 24.9375 27.1834 24.9375 30.0001C24.9375 32.8167 27.2041 35.1001 30 35.1001Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5999 19.8C32.5499 21.6 31.3124 23.325 29.9999 24.9C28.6499 23.2875 27.4499 21.6 26.3999 19.8C27.8249 17.925 29.0249 15.9 29.9999 13.7625C30.9749 15.9 32.2124 17.925 33.5999 19.8Z",
    fill: "#001A21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 35.0625C31.3499 36.675 32.5499 38.3625 33.5999 40.1625C32.1749 42.0375 30.9749 44.0625 29.9999 46.2C29.0249 44.0625 27.7874 42.0375 26.3999 40.1625C27.4499 38.4 28.6499 36.675 29.9999 35.0625Z",
    fill: "#001A21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 0C26.9999 4.9125 28.0874 9.5625 29.9999 13.7625C29.0249 15.9 27.7874 17.925 26.3999 19.8C25.2374 17.8125 24.2249 15.675 23.3999 13.5C25.6874 9.525 26.9999 4.9125 26.9999 0Z",
    fill: "#00F2F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 46.2375C28.0874 50.4375 26.9999 55.0875 26.9999 60C26.9999 55.0875 25.6874 50.475 23.3999 46.5C24.2249 44.2875 25.2374 42.1875 26.3999 40.2C27.7874 42.075 29.0249 44.1 29.9999 46.2375Z",
    fill: "#FFCB00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27 60H21C21 55.275 21.8625 50.7 23.4 46.5C25.6875 50.475 27 55.0875 27 60Z",
    fill: "#001A21"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27 0C27 4.9125 25.6875 9.525 23.4 13.5C21.8625 9.3 21 4.725 21 0H27Z",
    fill: "#001A21"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3999 19.8C27.4499 21.6 28.6874 23.325 29.9999 24.9C28.4624 26.7375 26.7749 28.4625 24.9374 30C23.3249 28.65 21.6374 27.45 19.8374 26.4C22.3124 24.525 24.5249 22.3125 26.3999 19.8Z",
    fill: "#FFCB00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 35.0626C28.6501 36.6751 27.4501 38.3626 26.4001 40.1626C24.5251 37.6501 22.3125 35.4376 19.8 33.5626C21.6 32.5126 23.3251 31.2751 24.9001 29.9626C26.7751 31.5376 28.4626 33.2251 30.0001 35.0626Z",
    fill: "#00F2F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3999 19.8C24.5249 22.3125 22.3124 24.525 19.7999 26.4C17.8124 25.2 15.6749 24.225 13.4624 23.4C17.5874 21.0375 20.9999 17.5875 23.3624 13.5C24.2249 15.675 25.2374 17.8125 26.3999 19.8Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 33.5999C22.3125 35.4749 24.525 37.6874 26.4 40.1999C25.2375 42.1874 24.225 44.3249 23.4 46.4999C21.0375 42.3749 17.5875 38.9624 13.5 36.5999C15.7125 35.7749 17.8125 34.7999 19.8 33.5999Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0C21 4.725 21.8625 9.3 23.4 13.5C21.0375 17.625 17.5875 21.0375 13.5 23.4C9.3 21.8625 4.725 21 0 21C11.5875 21 21 11.5875 21 0Z",
    fill: "#FFCB00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 46.4999C21.8625 50.6999 21 55.2374 21 60C21 48.4124 11.5875 38.9999 0 38.9999C4.725 38.9999 9.3 38.1374 13.5 36.5999C17.5875 38.9624 21.0375 42.4124 23.4 46.4999Z",
    fill: "#00F2F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H21C21 11.5875 11.5875 21 0 21V15C8.2875 15 15 8.2875 15 0Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21 60H15C15 51.7125 8.2875 45 0 45V39C11.5875 39 21 48.4125 21 60Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 26.4001C21.6 27.4501 23.325 28.6876 24.9 30.0001C23.2875 31.3126 21.6 32.5501 19.8 33.6001C17.925 32.1751 15.9 30.9751 13.7625 30.0001C15.9 29.0251 17.925 27.7876 19.8 26.4001Z",
    fill: "#001A21"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 26.4001C17.925 27.7876 15.9 29.0251 13.7625 30.0001C9.5625 28.0876 4.9125 27.0001 0 27.0001C4.9125 27.0001 9.525 25.6876 13.5 23.4001C15.7125 24.1876 17.8125 25.2001 19.8 26.4001Z",
    fill: "#00F2F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7625 30C15.9 30.975 17.925 32.175 19.8 33.6C17.8125 34.8 15.675 35.775 13.4625 36.6C9.525 34.3125 4.9125 33 0 33C4.9125 33 9.5625 31.9125 13.7625 30Z",
    fill: "#FFCB00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C15 8.2875 8.2875 15 0 15C0 6.7125 6.7125 0 15 0Z",
    fill: "#FFCB00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 45C8.2875 45 15 51.7125 15 60C6.7125 60 0 53.2875 0 45Z",
    fill: "#00F2F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 27C4.9125 27 9.5625 28.0875 13.7625 30C9.5625 31.9125 4.9125 33 0 33V27Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23.4C9.525 25.6875 4.9125 27 0 27V21C4.725 21 9.3 21.8625 13.5 23.4Z",
    fill: "#001A21"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33C4.9125 33 9.525 34.3125 13.5 36.6C9.3 38.1375 4.7625 39 0 39V33Z",
    fill: "#001A21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeLogoMob);
export default __webpack_public_path__ + "static/media/se_logo_mob.bb85c6732c0ae6b12077c195255b4feb.svg";
export { ForwardRef as ReactComponent };